<template>
  <v-dialog v-model="opened" width="500" v-if="this.model">
    <v-card :loading="this.loading" class="elevation-16 mx-auto" width="500">
      <v-card-title primary-title class="headline">
        {{ this.$props.title }}
      </v-card-title>
      <v-card-text>
        Conta pra gente o que você achou desta aula. Queremos sempre melhorar e
        por isso queremos muito saber a sua opinião.
        <div class="text-center mt-1">
          <v-form ref="form">
            <v-rating
              v-model="model.rating"
              color="yellow darken-3"
              background-color="grey darken-1"
              empty-icon="$ratingFull"
              hover
            ></v-rating>
            <v-textarea
              v-model="model.comments"
              auto-grow
              filled
              color="deep-purple"
              placeholder="Conte como foi a sua experiência com essa aula"
              rows="1"
              counter="300"
              v-validate="'max:300'"
              :v-errors="errors"
              :error-messages="errors.collect('comentário')"
              data-vv-name="comentário"
            ></v-textarea>
          </v-form>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="v-card--flat">
        <v-spacer></v-spacer>
        <v-btn min-width="120" outlined @click="closeDialog()" text
          >Outra hora</v-btn
        >
        <v-btn
          min-width="120"
          color="primary"
          @click="saveRating()"
          :disabled="!this.ratingValid()"
        >
          Avaliar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import RatingsService from "../../services/ratings.service";

export default {
  $_veeValidate: {
    validator: "new",
  },
  props: {
    model: {
      type: Object,
    },
    opened: {
      type: Boolean,
    },
    title: {
      type: String,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    closeDialog() {
      this.$emit("onCloseDialog");
    },
    saveRating() {
      this.formHasErrors().then((hasError) => {
        console.log(hasError);
        if (!hasError) {
          this.loading = true;
          RatingsService.saveRating(this.model)
            .then((res) => {
              this.loading = false;
              this.$emit("onSaveRating");
              this.closeDialog();
            })
            .catch((e) => {
              this.loading = false;
              console.log(e.message);
            });
        } else {
          console.log(hasError);
        }
      });
    },
    ratingValid() {
      if (this.model.rating == null) return false;
      if (this.model.comments !== null) {
        if (this.model.comments.length > 300) return false;
      }
      return true;
    },
  },
};
</script>
